import React from 'react';

interface IProps {
  description?: string;
}

const TextSection: React.FC<IProps> = ({ description }) => (
  <div className="flex items-stretch gap-4">
    <div className="w-1 bg-green-500 " />
    <p className="text-sm text-gray-700 whitespace-pre-line">{description}</p>
  </div>
);

export default TextSection;
